import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

// project imports
import { useNavTheme } from 'contexts/NavThemeContext';
import AnimatedBackground from 'components/AnimatedBackground';

// ==============================|| AUTH LAYOUT ||============================== //

export default function AuthLayout() {
  const { mode } = useNavTheme();
  const isLight = mode === 'light';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        background: isLight
          ? 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)'
          : 'linear-gradient(180deg, #0a0a0f 0%, #111118 100%)',
      }}
    >
      <AnimatedBackground />
      <Outlet />
    </Box>
  );
}
